<template>
  <div>
    <el-dialog
        title="审核人才输送"
        :visible.sync="isShow"
        width="550px"
        :close-on-click-modal="false"
        :before-close="dialogBeforeClose"
    >
      <el-form
          ref="auditFormDom"
          hide-required-asterisk
          :model="auditForm"
          :rules="auditFormRules"
          :label-width="'100px'"
      >
        <el-form-item label="审核理由" prop="auditInfo">
          <el-input
              type="textarea"
              :rows="3"
              class="w350"
              v-model="auditForm.auditInfo"
              placeholder="如审核结果为驳回，请输入具体原因。"
              maxlength="500" show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="footer-btns">
        <el-button type="primary" :loading="addbtnLoading" @click="handleFormAction('pass')">通过</el-button>
        <el-button type="danger" :loading="addbtnLoading" @click="handleFormAction('refused')">驳回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import playerTalentSend from '@/api/playerTalentSend'
import storage from '@/utils/storage'
import mixinAppConfig from "@/mixin/mixinAppConfig";


export default {
  mixins: [mixinAppConfig],
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    talentSendUuid: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      userRole: storage.get('userInfo').userRole,
      auditForm: {
        auditInfo: "",
      },
      btnStatus: "",
      addbtnLoading: false,
      allAmend: false,
    };
  },

  computed: {
    auditFormRules() {
      return {
        auditInfo: [
          {
            required: ['refused'].includes(this.btnStatus),
            message: "如审核结果为驳回，请输入具体原因。",
            trigger: ["blur", "change"],
          },
        ],
      };
    },

  },

  methods: {
    dialogBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:isShow", flag);
    },

    handleFormAction(stauts) {
      this.btnStatus = stauts;
      this.$nextTick(() => {
        this.$refs["auditFormDom"].validate((valid) => {
          if (valid) {
            this.addbtnLoading = true
            const {auditInfo} = this.auditForm;
            const postData = {
              auditInfo,
              auditStatus: stauts,
              talentSendUuid: this.talentSendUuid,
            };
            playerTalentSend.talentSendAudit(postData)
              .then((res) => {
                this.addbtnLoading = false
                if (res.code) {
                  this.$message.error(res.msg);
                  this.$emit('callback', false)
                  return;
                }
                this.setDialogStatus(false)
                this.$message.success("审核完成！");
                this.$emit('callback', true)
              })
              .catch((err) => {
                this.addbtnLoading = false
                this.$emit('callback', false)
                console.error("err", err);
              });
          }
        });
      });
    },


  },
};
</script>

<style lang="stylus" scoped>
.footer-btns
  width 60%
  margin 0 auto
  display flex
  justify-content space-around

.w350
  width 350px

.w300
  width: 340px

/deep/ .el-select-dropdown.is-multiple, /deep/ .el-select-dropdown__item.selected
  color $color_green
</style>
